import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Cookies } from "react-cookie";
import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";

export const societyDetails = createAsyncThunk("societyDetails", async (id) => {
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");
    const response = await AxiosInstance.get(
      `${API_KEY}/api/society/details/${id}`,

      {
        headers: {
          Authorization: `Barear ${token}`,
        },
        "Content-Type": "application/json",
      }
    );

    return response;
  } catch (error) {
    if (error.response) {
      throw error.response.data.message;
    } else {
      throw error;
    }
  }
});

const initialState = {
  isLoading: false,
  societyDetailsData: null,
  isError: false,
  errorMessage: "",
};
const societyDetailsSlice = createSlice({
  name: "societyDetails",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(societyDetails.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(societyDetails.fulfilled, (state, action) => {
      state.isLoading = false;
      state.societyDetailsData = action.payload;
    });
    builder.addCase(societyDetails.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default societyDetailsSlice.reducer;
